import axios from 'axios';

const state = () => ({
  currentMore: {},
});

const getters = {};

const mutations = {
  SET_CURRENT_MORE(state, more) {
    state.currentMore = more;
  },
};

const actions = {
  getMoreList() {
    return new Promise((resolve, reject) => {
      axios
        .get('/About')
        .then((res) => {
          const data = res.data
            .sort((a, b) => a.order - b.order)
            .filter((v) => v.key.startsWith('more.'))
            .map((v) => {
              return {
                id: v.id,
                key: v.key,
                value: v.value,
                routeName: 'MoreDetail',
              };
            });

          let items = [];

          // 固定項目
          items.push({
            key: 'more.chatHistory',
            value: null,
            routeName: 'MoreChatHistory',
          });

          items.push(...data);

          // 固定項目
          items.push({
            key: 'more.language',
            value: null,
            routeName: 'MoreLanguage',
          });

          resolve(items);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getMoreDetail(_, { aboutId, languageCode }) {
    return axios.get(`/AboutTranslation/${aboutId}/${languageCode}`);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
